import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';

const DEFAULT_MERCHANT = 'Walmart';
const DEFAULT_ADDRESS = '1235 Carnation Ave Los Angeles CA 91601';
const CASH_IN_LOCATIONS = [
  'Walmart Norco- 1235 Carnation Ave Los Angeles CA 91601',
  'Noho Walmart- 1234 Peonie Ave Austin TX 78666',
];

function formatCentsCurrency(valueInCents) {
  const cents = Number(valueInCents);
  if (Number.isNaN(cents)) {
    return '$0.00';
  }
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
}

function parsePickupLocation(selection) {
  const value = (selection || '').trim();
  if (!value) {
    return { locationName: '', locationAddress: '' };
  }

  const separatorIndex = value.indexOf('-');
  if (separatorIndex === -1) {
    return { locationName: value, locationAddress: '' };
  }

  return {
    locationName: value.slice(0, separatorIndex).trim(),
    locationAddress: value.slice(separatorIndex + 1).trim(),
  };
}

const DemoBarcode = ({ match, location, t }) => {
  const methodFromPath = match?.params?.method || '';
  const amountFromPath = match?.params?.amount;
  const queryParams = new URLSearchParams(location?.search || '');
  const flowMethod = methodFromPath || queryParams.get('method') || 'cash-out';
  const isCashIn = flowMethod === 'cash-in';
  const amountInCents = amountFromPath || queryParams.get('amount') || '0';
  const queryMerchant = queryParams.get('merchant') || '';
  const queryAddress = queryParams.get('address') || '';
  const [cashInLocation, setCashInLocation] = useState('');
  const [cashInError, setCashInError] = useState('');
  const [isCashInLocationConfirmed, setIsCashInLocationConfirmed] = useState(false);
  const parsedSelectedLocation = parsePickupLocation(cashInLocation);
  const selectedMerchant = parsedSelectedLocation.locationName || queryMerchant || DEFAULT_MERCHANT;
  const selectedAddress = parsedSelectedLocation.locationAddress || queryAddress || DEFAULT_ADDRESS;
  const shouldShowCashInSelector = isCashIn && !queryMerchant && !queryAddress && !isCashInLocationConfirmed;
  const spareLogo = `${process.env.PUBLIC_URL || ''}/images/spare_logo_s.png`;
  const walmartLogo = `${process.env.PUBLIC_URL || ''}/images/Walmart-Logo.png`;

  const handleCashInLocationSubmit = (event) => {
    event.preventDefault();
    const parsedLocation = parsePickupLocation(cashInLocation);

    if (!parsedLocation.locationName || !parsedLocation.locationAddress) {
      setCashInError('Please select a deposit location.');
      return;
    }

    setCashInError('');
    setIsCashInLocationConfirmed(true);
  };

  if (shouldShowCashInSelector) {
    return (
      <div className="demo-barcode-page">
        <main className="demo-barcode-shell">
          <section className="pickup-demo">
            <article className="pickup-demo__card demo-barcode-card">
              <img src={spareLogo} alt="Spare logo" className="demo-barcode-logo" />
              <p className="demo-barcode-caption">Your cash dropoff request has been accepted.</p>

              <div className="info-container demo-barcode-amount">
                <div className="info-header">
                  <h4>Dropoff amount</h4>
                  <h4>{formatCentsCurrency(amountInCents)}</h4>
                </div>
              </div>

              <div className="pickup-demo__instructions demo-barcode-disclaimers">
                <p>Select a dropoff location to continue to your barcode.</p>
              </div>

              {cashInError ? <p className="demo-barcode-error">{cashInError}</p> : null}

              <form onSubmit={handleCashInLocationSubmit} className="the-bank-demo__form demo-barcode-cash-in-form">
                <label htmlFor="cashInLocation">Drop-off location</label>
                <select
                  id="cashInLocation"
                  name="location"
                  value={cashInLocation}
                  onChange={(event) => setCashInLocation(event.target.value)}
                  required
                >
                  <option value="">Select a Walmart location</option>
                  {CASH_IN_LOCATIONS.map((pickupLocation) => (
                    <option key={pickupLocation} value={pickupLocation}>{pickupLocation}</option>
                  ))}
                </select>

                <button type="submit" className="demo-barcode-cash-in-submit">
                  Continue to barcode
                </button>
              </form>
            </article>
          </section>
        </main>
      </div>
    );
  }

  return (
    <div className="demo-barcode-page">
      <main className="demo-barcode-shell">
        <section className="pickup-demo">
          <article className="pickup-demo__card demo-barcode-card">
            <img src={spareLogo} alt="Spare logo" className="demo-barcode-logo" />
            <p className="demo-barcode-caption">
              {isCashIn ? 'This is your cash-in barcode.' : 'This is a one time redeemable barcode.'}
            </p>

            <div className="content-box-barcode barcode-white demo-barcode-image-wrap">
              <img
                src={`${process.env.PUBLIC_URL || ''}/images/Spare-demo-barcode.png`}
                alt={`One-time redeemable barcode ${amountInCents || ''}`.trim()}
                className="demo-barcode-image"
              />
            </div>

            <div className="pickup-demo__status">
              <p className="demo-barcode-id-label">Pickup Code</p>
              <div className="pickup-demo__code">{amountInCents || 'N/A'}</div>
            </div>

            <div className="info-container demo-barcode-amount">
              <div className="info-header">
                <h4>{isCashIn ? 'Dropoff amount' : t('pickup:pickup_amount')}</h4>
                <h4>{formatCentsCurrency(amountInCents)}</h4>
              </div>
            </div>

            <div className="location-info demo-barcode-location">
              <div className="demo-barcode-merchant-logo-wrap">
                <img
                  src={walmartLogo}
                  alt={`${selectedMerchant} logo`}
                  className="demo-barcode-merchant-logo"
                />
              </div>
              <div className="demo-barcode-address">{selectedAddress}</div>
            </div>

            <div className="pickup-demo__instructions demo-barcode-disclaimers">
              <p>{t('pickup:disclaimer_label')}</p>
              <ul>
                <li>{t('pickup:bring_id')}</li>
                <li>{t('pickup:disclaimer_fee')}</li>
                <li>{t('pickup:disclaimer_receipt')}</li>
              </ul>
              <div className="demo-barcode-legal">{t('pickup:walmartLegal')}</div>
            </div>
          </article>
        </section>
      </main>
    </div>
  );
};

export default withTranslation('pickup')(DemoBarcode);
